import React, { useState } from 'react';
import './index.scss';

const AddVideo = () => {
  const [showVideo, setShowVideo] = useState(false);

  const handlePlayClick = () => {
    setShowVideo(true);
  };

  return (
    <div className="addVideoScetion">
      <div className="addVideoContainer">
        <div className="addVideoTextSection">
          <h3>Crush prescription prices with SingleCare</h3>
          <p>
            See how SingleCare can help you pay less for your prescription so
            you can invest more in things that matter to you.
          </p>
        </div>

        <div className="addVideoIframe">
          {showVideo ? (
            <video controls autoPlay playsInline loading="lazy">
              <source
                src="/content/video/SingleCare-Pickleball.mp4"
                type="video/mp4"
              />
              Your browser does not support the video tag.
            </video>
          ) : (
            <div className="videoPosterOverlay" onClick={handlePlayClick}>
              <button
                className="playButton"
                aria-label="Play video: Crush prescription prices with SingleCare"
              ></button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddVideo;
